import TwoUsersIcon from "icons/TwoUsersIcon";

export const ACTION_TYPES = {
    TAKE_ATTENDANCE: 1,
    PENALIZE: 2,
    DELETE: 3,
    ADD: 4
};
export const TITLES_OF_DIALOG_CONFIRMATION = {
    TAKE_STUDENT_ATTENDANCE: {
        ALL_STUDENTS: "¿Deseas marcar la asistencia de todos los alumnos?",
        SOME_STUDENTS: "¿Deseas marcar la asistencia de los alumnos?",
        ONE_STUDENT: "¿Deseas marcar la asistencia de un alumno?"
    }
};
export const MESSAGES_VALIDATION_REQUEST_PENALIZE = {
    UPDATE_PENALTY: "SANCIONES_DIFERENTES"
};
export const HEADER_TABLE_LIST = [
    { 
        icon: <TwoUsersIcon/>, title: "Alumnos",
        styleProps: { justify: "flex-start" }
    },
    { title: "Estado" },
    { title: "Selección" }
];